import React, { useEffect, useState } from "react";
import { PharmacyService } from "../../../api/PharmacyService";

import { SkillType, workerTypeEnum } from "../../../util/Enumeration";
import { LoadingIndicator } from "../../../components/LoadingIndicator";
import { Formik, Form } from "formik";
import { RBMultipleSelectForForm, RBSelectForForm, RBSkillSelectForForm } from "../../../components/RBTextField";
import { Spacing, Colors } from "../../../theme/Theme";
import { skillTextStyle } from "../../../theme/ComponentTheme";
import {
  MenuItem,
  ListItemText,
  Checkbox,
  Typography,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import { Claims } from "../../../util/Common";
import { RBDropFile } from "../../../components/RBDropFile";
import { RBButton } from "../../../components/RBButton";
import Popup from "reactjs-popup";
import SignaturePad  from "../../../components/SignaturePad"
import moment from "moment";
import { SkillResponseDto } from "../../../dtos/Skill.dto";
import _ from "lodash";

export interface SkillsValueTypes {
  resume: File | undefined;
  signature: string | undefined;
  [key: string]: any;
}

interface SkillsProps {
  innerRef?: any;
  onFormChange: any;
  previousFormData?: any;
  initialValues: SkillsValueTypes;
  workerType?: any;
  account?:any;
  onSkillsChange?:any;
  industryMode?: any;
}
export const Skills: React.FC<SkillsProps> = ({ ...props }) => {
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isSignatureVisible, setIsSignatureVisible] = useState(false);
  const [savedSignatureDataURL, setSavedSignatureDataURL] = useState('');
  const [viewSign, setViewSign] = useState(false);
  const [skillsByType, setSkillsByType] = useState<Record<string, SkillResponseDto[]>>({});

  useEffect(() => {
    const fetchData = async () => {
      setIsPageLoading(true);
      const skillSet = props.account?.networks?.[0]?.skillSet;
      const workerSkillSets = skillSet?.workerSkillSets || [];
      const skillsResponse = await PharmacyService.fetchSkills(workerSkillSets, props.industryMode, props.workerType);
      const rawSkills = skillsResponse.data;

      // Group skills by their `type`
      const groupedSkills = rawSkills.reduce((acc: any, skill: any) => {
        const type = skill.type || 'unknown'; // Fallback if type is missing
        if (!acc[type]) {
          acc[type] = [];
        }
        acc[type].push(skill);
        return acc;
      }, {} as Record<string, any[]>);

      // Now set the grouped result
      setSkillsByType(groupedSkills);
      setIsPageLoading(false);
    };
    fetchData();
  }, []);

  const onMultipleChange = (e: any) => {
    console.log("onMultipleChange ", e.target.value);
  };
  // useEffect(() => {
  //   props.onSkillsChange?.(skillsByType); // whenever skills state updates
  // }, [skillsByType]);


  const handleCancel = () => {
    setIsSignatureVisible(false);
    localStorage.removeItem("workerSign")
    setSavedSignatureDataURL('');
  };
   const skillFieldInitialValues = Object.keys(skillsByType).reduce<Record<string, string>>((acc, type) => {
    const fieldName = `skills${_.startCase(type).replace(/\s/g, '')}`;
    acc[fieldName] = props.initialValues[fieldName] || '';
    return acc;
  }, {});
  
    // Merge with rest of initial values
    const formInitialValues = {
      ...props.initialValues,
      ...skillFieldInitialValues
    };
  const skillLabels = Object.keys(skillsByType).map((type) => {
    if (type.toLowerCase().includes('specialization')) {
      return 'skills';
    }
    return type.toLowerCase();
  });
  const formatList = (list: string[]) => {
    if (list.length === 0) return '';
    if (list.length === 1) return list[0];
    return `${list.slice(0, -1).join(', ')} and ${list[list.length - 1]}`;
  };

  const dynamicSkillText = `Please select all applicable ${formatList(skillLabels)}.`;
  const workerMultiSelects = props?.account?.networks?.[0]?.skillSet?.workerMultiSelects || [];

  return (
    <div>
      {isPageLoading ? (
        <LoadingIndicator />
      ) : (
        <>
          <Typography variant="body1" style={{ marginBottom: Spacing.large }}>
           {dynamicSkillText}
          </Typography>
          <Formik
            initialValues={formInitialValues}
            innerRef={props.innerRef}
            // validationSchema={Schema.UserLocation}
            validateOnBlur={false}
            validateOnMount={true}
            validateOnChange={true}
            isInitialValid={true}
            onSubmit={() => {}}
          >
            {({
              values,
              errors,
              isSubmitting,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form
                onSubmit={handleSubmit}
                // basically call onFormChange to check if the form is valid
                onKeyUp={props.onFormChange}
                onMouseDown={props.onFormChange}
              >
                  {Object.keys(skillsByType)?.map((type) => {
                    const skillList = skillsByType[type];
                    const fieldName = `skills${_.startCase(type).replace(/\s/g, '')}`;
                    const isMultiSelect = workerMultiSelects.includes(type);
                    return (
                      isMultiSelect?
                      (<RBMultipleSelectForForm
                        key={type}
                        label={type.includes('specialization') ? 'Skills' :_.startCase(type)} // "Software", "Specialization", etc.
                        name={fieldName}
                        value={values[fieldName] || []}
                        onChange={handleChange}
                        renderValue={(selected) => (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                            }}
                          >
                            {(selected as string[]).map((skillID) => {
                              const skill = skillList.find((s) => s.id === skillID);
                              return (
                                <div key={skillID} style={skillTextStyle}>
                                  {skill?.name}
                                </div>
                              );
                            })}
                          </div>
                        )}
                        style={{ marginBottom: Spacing.larger }}
                      >
                        {skillList.map((skill) => (
                          <MenuItem key={skill.id} value={skill.id}>
                            <Checkbox
                              checked={values[fieldName]?.indexOf(skill.id) > -1}
                              style={{
                                color:
                                  values[fieldName]?.indexOf(skill.id) > -1
                                    ? localStorage.getItem("secondaryColor") ?? Colors.themeLightBlue
                                    : Colors.darkGrey,
                              }}
                            />
                            <ListItemText primary={skill.name} />
                          </MenuItem>
                        ))}
                      </RBMultipleSelectForForm>)
                      :
                        (
                          <RBSkillSelectForForm
                            key={type}
                             labelId={`${fieldName}-label`}
                            label={_.startCase(type)} // "Software", "Specialization", etc.
                            name={fieldName}
                            value={values[fieldName]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder={`Select ${_.startCase(type)}`}
                            style={{
                              marginBottom: Spacing.large,
                            }}
                          >
                            <MenuItem value="">
                              Select
                            </MenuItem>
                            {skillList?.map((skill) => (
                              <MenuItem key={skill.id} value={skill.id}>
                                {skill.name}
                              </MenuItem>
                            ))}
                          </RBSkillSelectForForm>
                        )
                    );
                  })}

                <Typography  variant="body1" style={{ marginBottom: Spacing.large }}>
                  <h3>Resume and Registering Body Documents (PDF Only)</h3>
                </Typography>
                <Typography  variant="body1" style={{ marginBottom: Spacing.large }}>
                *If you are unable to upload your resume right now, you may send it to us by replying to the registration confirmation email you will receive. 
                </Typography>
                <RBDropFile
                  dropzoneText={
                    "Drag and drop PDF file here"
                  }
                  acceptedFiles={[".pdf"]}
                  initialFiles={values.resume ? [values.resume] : []}
                  // onChange
                  showPreviews={true}
                  showFileNamesInPreview={true}
                  showPreviewsInDropzone={false}
                  onChange={(file) => {
                    console.log("on change ", file);
                    if (file.length === 1) {
                      setFieldValue("resume", file[0], true);
                    }
                  }}
                  onDelete={(file) => {
                    setFieldValue("resume", undefined, true);
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "flex-end",
                  }}
                >
                  <Typography  variant="body1" style={{ marginBottom: Spacing.medium }}>
                    <h3>Signature (Optional)</h3> 
                  </Typography>
                  {savedSignatureDataURL && 
                  <Typography  variant="body1" style={{ marginBottom: Spacing.medium, paddingLeft:"10%" }}>
                    <h5><a onClick={() => setViewSign(!viewSign)} style={{color:Colors.themeDarkBlue}}>View</a></h5> 
                  </Typography>}
                </div>
                {savedSignatureDataURL && viewSign && (
                    <div style={{ maxWidth: '100%', width: '100%', overflow: 'hidden',border: '1px solid black' }}>
                      <img src={savedSignatureDataURL} alt="Saved Signature" style={{ width: '100%', height: 'auto' }}/>
                    </div>
                  )}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "flex-end",
                  }}
                >
                  {!isSignatureVisible && <RBButton
                    key={"back"}
                    onClick={() => {
                      if(savedSignatureDataURL == '')
                      {
                        setIsSignatureVisible(true);
                      }
                    }}
                    style={{
                      display: "flex",
                      flex: 1,
                      padding: Spacing.medium,
                      margin: Spacing.large,
                      background:localStorage.getItem("secondaryColor") ?? Colors.themeLightBlue
                    }}
                    text="Create e-signature"
                  />}
                  {localStorage.getItem("workerSign") && <RBButton
                    key={"back"}
                    onClick={() => {
                      setIsSignatureVisible(false);
                      setSavedSignatureDataURL('');
                      localStorage.removeItem("workerSign")
                      //console.log("savedSignatureDataURL",savedSignatureDataURL)
                    }}
                    style={{
                      display: "flex",
                      flex: 1,
                      padding: Spacing.medium,
                      margin: Spacing.large,
                      background:localStorage.getItem("secondaryColor") ?? Colors.themeLightBlue
                    }}
                    text="Clear"
                  />}
                </div>
                  <SignaturePad
                    isVisible={isSignatureVisible}
                    onLoad = {(file,dataURL) =>{
                      setSavedSignatureDataURL(dataURL);
                      setFieldValue("signature", file, true);
                    }}
                    onSave={(file,dataURL) =>{
                     // handleSave
                      setSavedSignatureDataURL(dataURL);
                      setIsSignatureVisible(false);
                      setViewSign(false)
                      setFieldValue("signature", file, true);
                    }}
                    onCancel={handleCancel}
                    onClear={() => {
                      setSavedSignatureDataURL('');
                      localStorage.removeItem("workerSign")
                    }}
                    userData = {props.previousFormData}
                    page="workerRegistration"
                  />
          
              </Form>
            )}
          </Formik>
        </>
      )}
    </div>
  );
};
